import { Input } from 'antd';
import { useMemo, useState } from 'react';
import { DownOutlined } from '@ant-design/icons';
import Modal from 'components/Modal';
import classlist from 'utils/classlist';
import { FieldSelectProps } from '..';
import SinglePickerView from './SinglePickerView';

import './style.scss';

const Picker: React.FC<FieldSelectProps> = ({
    placeholder = __('请选择'),
    value = '',
    disabled,
    data = [],
    optionLabelProp,
    onChange,
    className,
    size,
    ...rest
}) => {
    const [open, setOpen] = useState(false);

    const handleSelect = () => {
        if (!disabled) {
            setOpen(true);
        }
    };

    const handelCancel = () => {
        setOpen(false);
    };

    const valueText = useMemo(() => {
        const currItem = data.find(item => item.value === value);

        if (optionLabelProp && currItem) {
            return currItem[optionLabelProp];
        }

        if (String(value) && currItem) {
            return currItem.label;
        }

        if (String(value)) {
            return value;
        }

        return '';
    }, [data, optionLabelProp, value]);

    const handleChange = v => {
        onChange?.(v);
        handelCancel();
    };

    return (
        <div className={classlist('field-select-picker', className)}>
            <Input
                readOnly
                size={size}
                placeholder={placeholder}
                value={valueText}
                disabled={disabled}
                onClick={handleSelect}
                suffix={<DownOutlined />}
            />
            <Modal
                open={open}
                wrapClassName="comm-modal-wrap portal-modal-wrap"
                transitionName="portal-move-down"
                maskClosable
                closable
                className="field-select-picker"
                onCancel={handelCancel}
                footer={null}>
                <SinglePickerView {...rest} onChange={handleChange} value={value} data={data} />
            </Modal>
        </div>
    );
};

export default Picker;
